import React from "react";
import Typography from "@mui/material/Typography";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { PollActions } from "@Store";
import { ChannelActions } from "@Store";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

type ChannelModalTypes = {
    openDialog: boolean;
    onClose: () => void;
    pollId: string;
    channelId: string;
};

export const ClosePoll: React.FC<ChannelModalTypes> = ({
    openDialog,
    onClose,
    pollId,
    channelId,
}: ChannelModalTypes) => {
    const { t } = useTranslation();
    const dispatch = useDispatch<any>();

    const handleCloseChannel = () => {
        dispatch(PollActions.closePoll(pollId, channelId));
        dispatch(ChannelActions.fetchChannelPolls(channelId));
        onClose();
    };

    return (
        <>
            <Dialog
                open={openDialog}
                onClose={onClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    <Typography variant="h6">
                        {t("dialogs.close_poll")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 1,
                            top: 1,
                            color: "grey.500",
                        }}
                        size="large"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <p>{t("dialogs.close_poll_desc1")}</p>
                        <p style={{ textAlign: "center" }}>
                            {t("dialogs.close_poll_desc2")}
                        </p>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} size="small" color="secondary">
                        {t("dialogs.cancel")}
                    </Button>
                    <Button
                        onClick={handleCloseChannel}
                        variant="contained"
                        size="small"
                        color="secondary"
                        type="submit"
                    >
                        {t("dialogs.close_poll")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
